
import { supabase } from '@/integrations/supabase/client';

interface RateLimitConfig {
  maxAttempts: number;
  windowMs: number;
  blockDurationMs: number;
}

interface RateLimitRecord {
  id: string;
  user_id: string;
  action: string;
  attempts: number;
  window_start: string;
  blocked_until: string | null;
  created_at: string;
  updated_at: string;
}

const DEFAULT_CONFIG: RateLimitConfig = {
  maxAttempts: 5,
  windowMs: 15 * 60 * 1000, // 15 minutes
  blockDurationMs: 30 * 60 * 1000, // 30 minutes
};

export class ServerRateLimiter {
  private config: RateLimitConfig;

  constructor(config: Partial<RateLimitConfig> = {}) {
    this.config = { ...DEFAULT_CONFIG, ...config };
  }

  async checkLimit(userId: string, action: string): Promise<{ allowed: boolean; resetTime?: number }> {
    // TEMPORARY FIX: Disable rate limiting due to Supabase table issues
    console.log('[RateLimiter] DISABLED - allowing all requests for:', { userId, action });
    return { allowed: true };
  }

  async resetLimit(userId: string, action: string): Promise<void> {
    // TEMPORARY FIX: Disable rate limiting due to Supabase table issues
    console.log('[RateLimiter] DISABLED - resetLimit called for:', { userId, action });
    return;
  }
}

// Create rate limiter instances for different actions
export const loginRateLimiter = new ServerRateLimiter({
  maxAttempts: 5,
  windowMs: 15 * 60 * 1000, // 15 minutes
  blockDurationMs: 30 * 60 * 1000, // 30 minutes
});

export const passwordResetRateLimiter = new ServerRateLimiter({
  maxAttempts: 3,
  windowMs: 60 * 60 * 1000, // 1 hour
  blockDurationMs: 2 * 60 * 60 * 1000, // 2 hours
});

export const apiRateLimiter = new ServerRateLimiter({
  maxAttempts: 100,
  windowMs: 60 * 1000, // 1 minute
  blockDurationMs: 5 * 60 * 1000, // 5 minutes
});
